import { IfcGeometricRepresentationItem } from "./index.js";
import { IfcCurveDim, } from "../ifc_functions.js";
/* This is generated code, don't modify */
import EntityTypesIfc from "./entity_types_ifc.gen.js";
///**
// * http://www.buildingsmart-tech.org/ifc/ifc4/final/html/link/ifccurve.htm */
export class IfcCurve extends IfcGeometricRepresentationItem {
    get type() {
        return EntityTypesIfc.IFCCURVE;
    }
    get Dim() {
        return IfcCurveDim(this);
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
IfcCurve.query = [EntityTypesIfc.IFCLINE, EntityTypesIfc.IFCOFFSETCURVE2D, EntityTypesIfc.IFCOFFSETCURVE3D, EntityTypesIfc.IFCPCURVE, EntityTypesIfc.IFCSURFACECURVE, EntityTypesIfc.IFCCOMPOSITECURVE, EntityTypesIfc.IFCINDEXEDPOLYCURVE, EntityTypesIfc.IFCPOLYLINE, EntityTypesIfc.IFCTRIMMEDCURVE, EntityTypesIfc.IFCBSPLINECURVEWITHKNOTS, EntityTypesIfc.IFCRATIONALBSPLINECURVEWITHKNOTS, EntityTypesIfc.IFCCOMPOSITECURVEONSURFACE, EntityTypesIfc.IFCBOUNDARYCURVE, EntityTypesIfc.IFCOUTERBOUNDARYCURVE, EntityTypesIfc.IFCCIRCLE, EntityTypesIfc.IFCELLIPSE, EntityTypesIfc.IFCINTERSECTIONCURVE, EntityTypesIfc.IFCSEAMCURVE];
IfcCurve.expectedType = EntityTypesIfc.IFCCURVE;
